<template>
    <div class="course-circle">
        <div class="circle">
            <div :class="color"></div>
            <div :class="`shadow-${color}`"></div>
        </div>
        <div class="text" v-html="text"></div>
    </div>
</template>
<script>
export default {
    name: 'CourseCircle',
    components: {

    },
    props: {
        color: {
            type: String,
            default: 'blue'
        },
        text: {
            type: String,
            default: '<span>簽核</span><br><span>100%</span>'
        }
    },
    setup(){

        return {

        }
    }
}
</script>
<style lang="scss">
@use "sass:map";
$circle-color: (
    "blue": (
        color1: #9EC5FF,
        color2: #569affde,
        color3: #217affde,
        color4: #074DFF
    ),
    "red": (
        color1: #FF9E9E,
        color2: #fc5858df,
        color3: #ff2121de,
        color4: #FF0101
    ),
    "yellow": (
        color1: #FDFF9E,
        color2: #fcff56de,
        color3: #fff621de,
        color4: #FFF501
    ),
    "green": (
        color1: #BDFF9E,
        color2: #82ff56de,
        color3: #4dff21de,
        color4: #07FF11
    ),
    "white": (
        color1: #767676,
        color2: #c4c4c4de,
        color3: #bfbfc0de,
        color4: #FFFFFF
    )
);
.course-circle {
    position: relative;
    .circle {
        width: 25px;
        height: 25px;
        position: relative;
    }
    .text {
        text-align: center;
        position: absolute;
        left: 50%;
        bottom: 0px;
        transform: translate(-50%, 100%);
        white-space: nowrap;
        font-size: smaller;
        line-height: 12px;
    }
}
@each $name, $clr in $circle-color {
    .#{$name} {
        width: 23px;
        height: 23px;
        border-radius: 50%;
        filter: blur(0.25);
        background: linear-gradient(180deg, map.get($circle-color, $name, color1) 3.85%, map.get($circle-color, $name, color2) 92.31%, map.get($circle-color, $name, color3) 96.15%);
        position: absolute;
        transform: translate(-50%, -50%);
        z-index: 2;
        left: 50%;
        top: 50%;
    }
    .shadow-#{$name} {
        border-radius: 50%;
        width: 25px;
        height: 25px;
        transform: translate(-50%, -50%);
        left: 50%;
        top: 50%;
        background: map.get($circle-color, $name, color4);
        position: absolute;
        z-index: 1;
        filter: blur(1px) drop-shadow(0px 2px 2px rgba(0, 0, 0, 0.25));
    }
};
</style>